// index.js
const env = process.env.NODE_ENV;

let config;
switch (env) {
  case "production":
    config = require("./production").default;
    break;
  case "development":
    config = require("./development").default;
    break;
  default:
    throw new Error(`No config found for environment: ${env}`);
}

export default config;
